<form [formGroup]="form">
  <div class="flex justify-between gap-4 pt-2 px-6 items-center">
    <mat-form-field
      class="input-tg mt-message-input w-1/3"
      appearance="outline"
    >
      <mat-label>Banco</mat-label>
      <input matInput formControlName="bank" />
    </mat-form-field>
    <mat-form-field
      class="input-tg mt-message-input w-1/3"
      appearance="outline"
    >
      <mat-label>Agência</mat-label>
      <input matInput formControlName="bank_branch" />
    </mat-form-field>
    <mat-form-field
      class="input-tg mt-message-input w-1/3"
      appearance="outline"
    >
      <mat-label>Conta</mat-label>
      <input matInput formControlName="bank_account" />
    </mat-form-field>
  </div>
  <div class="flex justify-between gap-4 px-6 items-center">
    <mat-form-field class="input-tg no-message w-full" appearance="outline">
      <mat-label>Pix</mat-label>
      <input matInput formControlName="pix" />
    </mat-form-field>
  </div>
  <div class="flex justify-end gap-4 py-2 mb-2 px-6 items-center">
    <button
      mat-flat-button
      class="btn-tg w-1/5"
      [disabled]="form.invalid || loading"
      (click)="createItem()"
    >
      @if (loading) {
        <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
      } @else {
        Adicionar Novo
      }
    </button>
  </div>
</form>
